var map = {
	"./alex_albon.svg": 3587,
	"./alfa_romeo.svg": 4957,
	"./alpha_tauri.svg": 3136,
	"./alpine.svg": 8947,
	"./aston_martin.svg": 6739,
	"./carlos_sainz.svg": 6087,
	"./charles_leclerc.svg": 2017,
	"./esteban_ocon.svg": 2990,
	"./f1.svg": 8379,
	"./fernando_alonso.svg": 626,
	"./ferrari.svg": 8370,
	"./george_russell.svg": 8155,
	"./haas.svg": 1136,
	"./kevin_magnussen.svg": 7579,
	"./kick_sauber.svg": 9518,
	"./lance_stroll.svg": 4688,
	"./lando_norris.svg": 5321,
	"./lewis_hamilton.svg": 5718,
	"./logan_sargeant.svg": 6607,
	"./max_verstappen.svg": 5501,
	"./mclaren.svg": 1141,
	"./mercedes.svg": 8420,
	"./nico_hulkenberg.svg": 6691,
	"./nyck_de_vries.svg": 1403,
	"./oscar_piastri.svg": 3140,
	"./pierre_gasly.svg": 1300,
	"./red_bull.svg": 840,
	"./sergio_perez.svg": 54,
	"./valtteri_bottas.svg": 1988,
	"./visa_cashapp_rb.svg": 3288,
	"./williams.svg": 3377,
	"./yuki_tsunoda.svg": 4125,
	"./zhou_guanyu.svg": 3793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198;